import { type ReactNode } from 'react';
import { Box, type BoxProps } from '../../layout/Box';
import { Typography } from '../../layout/Typography';
import { CheckCircleIcon } from '../../icons/lingodaIcons';

export interface SlidePopupSuccessLayoutProps {
    sx?: BoxProps['sx'];
    message: ReactNode;
}

export const SlidePopupSuccessLayout = ({ sx, message }: SlidePopupSuccessLayoutProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                ...sx,
            }}
        >
            <Box
                component={CheckCircleIcon}
                size={24}
                weight="fill"
                sx={(theme) => ({ color: theme.colors.text.success })}
            />
            <Typography variant="subtitle1" mt={1}>
                {message}
            </Typography>
        </Box>
    );
};
